import { render, staticRenderFns } from "./UserSelectDialog.vue?vue&type=template&id=5cc525c5&"
import script from "./UserSelectDialog.vue?vue&type=script&lang=js&"
export * from "./UserSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectDialog.vue?vue&type=style&index=0&id=5cc525c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports